import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import CheckIcon from '@material-ui/icons/Check';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';

const useStyles = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow:
      'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#fff',
    transition: 'all 0.3s',
    'input:disabled ~ &': {
      opacity: 0.4,
    },
    'input:hover ~ &': {
      boxShadow:
        'inset 0 0 0 1px rgba(24, 34, 139,1), inset 0 -1px 0 rgba(24, 34, 139,1)',
    },
  },
  checkedIcon: {
    backgroundColor: '#5b346d',
    borderRadius: 3,
    width: 16,
    height: 16,
    color: '#fff',
    'input:hover ~ &': {
      backgroundColor: '#5b346d',
      opacity: 1,
    },
  },

  inderminateIcon: {
    width: 20,
    height: 20,
  },
});

// Inspired by blueprintjs
const StyledCheckbox = (props) => {
  const classes = useStyles();

  return (
    <Checkbox
      className={classes.root}
      color="default"
      checkedIcon={<CheckIcon className={classes.checkedIcon} />}
      icon={<span className={classes.icon} />}
      inputProps={{ 'aria-label': 'decorative checkbox' }}
      indeterminateIcon={
        <IndeterminateCheckBoxIcon className={classes.inderminateIcon} />
      }
      {...props}
    />
  );
};

export default StyledCheckbox;
